/**
 * Payin journey steps
 */
import { Navigate, Outlet } from 'react-router-dom';

import { getCurrencySymbol } from '@/locale';
import ClientContainer from '@/services/client/ClientContainer';
import JourneyContainer from '@/services/journeys/JourneyContainer';
import ProvidersLibsContainer from '@/services/providersLibs/ProvidersLibsContainer';
import PayinAudience from '@/features/payin/PayinAudience';
import PayinActivity from '@/features/payin/PayinActivity';
import PayinBillingAddress from '@/features/payin/PayinBillingAddress';
import PayinPaymentForm from '@/features/payin/PayinPaymentForm';
import PayinPaymentSuccess from '@/features/payin/PayinPaymentSuccess';
import PaymentSubmitted from '@/features/paymentProcess/PaymentSubmitted';
import PaymentFailure from '@/features/paymentProcess/PaymentFailure';
import PaymentError from '@/features/paymentProcess/PaymentError';
import UserDetails from '@/features/userDetails/UserDetails';

const payInRouteSteps = 6;

const currencySymbol = getCurrencySymbol();

const payinRoutes = {
  path: '/payin',
  element: (
    <ClientContainer clientOverride="payin">
      <ProvidersLibsContainer>
        <JourneyContainer journey="payin">
          <Outlet />
        </JourneyContainer>
      </ProvidersLibsContainer>
    </ClientContainer>
  ),
  children: [
    // Redirect from "/payin" index to "./audience"
    {
      path: '',
      element: <Navigate to="./audience" replace />,
    },
    {
      path: 'audience',
      element: <PayinAudience />,
    },
    {
      path: 'activities',
      element: <PayinActivity />,
    },
    {
      path: 'user-details',
      element: <UserDetails
        totalSteps={payInRouteSteps}
        currencySymbol={currencySymbol}
      />,
    },
    {
      path: 'billing-address',
      element: <PayinBillingAddress
        totalSteps={payInRouteSteps}
        currencySymbol={currencySymbol}
      />,
    },
    {
      path: 'card-payment',
      element: <PayinPaymentForm
        totalSteps={payInRouteSteps}
        currencySymbol={currencySymbol}
      />,
    },
    {
      path: 'success',
      element: <PayinPaymentSuccess
        totalSteps={payInRouteSteps}
        currencySymbol={currencySymbol}
      />,
    },
    {
      path: 'submitted',
      element: <PaymentSubmitted
        totalSteps={payInRouteSteps}
        currencySymbol={currencySymbol}
      />,
    },
    {
      path: 'failure',
      element: <PaymentFailure />,
    },
    {
      path: 'error',
      element: <PaymentError />,
    },
  ],
};

export default payinRoutes;
